<script setup>
import { ref, watch } from "vue";
import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from "@headlessui/vue";

const isOpen = ref(false);

const props = defineProps({
    videoButtonText: {
        type: String,
        required: true,
    },
    modalVideo: {
        type: String,
        required: true,
    },
});
</script>
<template>
    <div>
        <button class="flex space-x-5 items-center" @click="isOpen = !isOpen">
            <div class="flex w-8 h-8 md:h-10 md:w-10">
                <div
                    class="animate-ping absolute inline-flex rounded-full bg-white opacity-75 w-8 h-8 md:h-10 md:w-10"
                ></div>
                <div
                    class="relative inline-flex justify-center items-center rounded-full w-8 h-8 md:w-10 md:h-10 bg-white"
                >
                    <svg
                        aria-hidden="true"
                        data-prefix="fas"
                        data-icon="play"
                        class="svg-inline--fa fa-play fa-w-14 w-3.5 h-auto fill-current text-orange"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                    >
                        <path
                            fill="currentColor"
                            d="M424.4 214.7 72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
                        />
                    </svg>
                </div>
            </div>
            <span class="text-lg text-white" v-text="videoButtonText" />
        </button>
        <TransitionRoot as="template" :show="isOpen">
            <Dialog as="div" class="fixed z-10 inset-0 overflow-y-auto" @close="isOpen = false">
                <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <TransitionChild
                        as="template"
                        enter="ease-out duration-300"
                        enter-from="opacity-0"
                        enter-to="opacity-100"
                        leave="ease-in duration-200"
                        leave-from="opacity-100"
                        leave-to="opacity-0"
                    >
                        <DialogOverlay class="fixed inset-0 bg-black bg-opacity-75 transition-opacity z-10" />
                    </TransitionChild>

                    <!-- This element is to trick the browser into centering the modal contents. -->
                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                    <TransitionChild
                        as="template"
                        enter="ease-out duration-300"
                        enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leave-from="opacity-100 translate-y-0 sm:scale-100"
                        leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div
                            class="inline-block align-bottom bg-white rounded-xl px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full sm:p-6 z-10 relative"
                        >
                            <div class="rounded-xl overflow-hidden">
                                <video width="500" height="300" controls autoplay class="w-full">
                                    <source :src="modalVideo" type="video/mp4" />
                                    Deze browser ondersteunt geen video tag.
                                </video>
                            </div>
                            <div class="mt-5 sm:mt-6 flex justify-center">
                                <button
                                    type="button"
                                    class="py-2 px-5 rounded-xl bg-orange hover:bg-orange-600 text-white border border-orange font-semibold max-w-fit transition duration-500 ease-in-out"
                                    @click="isOpen = false"
                                >
                                    Sluit video
                                </button>
                            </div>
                        </div>
                    </TransitionChild>
                </div>
            </Dialog>
        </TransitionRoot>
    </div>
</template>
